var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2594_315)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2594_315)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.43042,
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_2594_315)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    d: "M-19.3479 10.5173V15.6394C-9.78311 19.6444 3.04054 22.0941 17.1356 22.0941C31.0977 22.0941 43.8124 19.6904 53.3478 15.7522V10.5173H-19.3479Z",
    fill: "url(#paint1_linear_2594_315)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.4304C10 16.1652 10.1054 15.9108 10.2929 15.7233C10.4804 15.5358 10.7348 15.4304 11 15.4304H23C23.2652 15.4304 23.5196 15.5358 23.7071 15.7233C23.8946 15.9108 24 16.1652 24 16.4304C24 16.6956 23.8946 16.95 23.7071 17.1375C23.5196 17.3251 23.2652 17.4304 23 17.4304H11C10.7348 17.4304 10.4804 17.3251 10.2929 17.1375C10.1054 16.95 10 16.6956 10 16.4304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 1.40688,
    y: 0.837299,
    width: 31.1862,
    height: 31.1862,
    rx: 7.59312,
    stroke: "url(#paint2_linear_2594_315)",
    strokeWidth: 0.813757,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2594_315",
    x: 0.186243,
    y: 0.43042,
    width: 33.6275,
    height: 36.0688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25503
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.406879
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2594_315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2594_315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2594_315",
    x1: 17,
    y1: 0.43042,
    x2: 17,
    y2: 32.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1087B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2594_315",
    x1: 16.9999,
    y1: 9.97483,
    x2: 16.9999,
    y2: 22.0941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2594_315",
    x1: 17,
    y1: 0.43042,
    x2: 17,
    y2: 32.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2594_315"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.43042,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.7e1cf50000c876ed7c8238049a1aff44.svg";
export { ForwardRef as ReactComponent };